import React, { useEffect, useState } from "react";
import "../../AdminScreens/AllEmployees/AllEmployees.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import { GrRefresh } from "react-icons/gr";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import { Modal } from "react-bootstrap";
import { RiEyeCloseFill } from "react-icons/ri";
import { AiOutlineEye, AiOutlineDownload } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";
import {
  Apiurl,
  GetToken,
  downloadFile,
  downloadMultipleFiles,
} from "../../../Utils/utils";
import Loader from "../../../Components/loader/loader";
import dummyimage from "../../../Assets/Images/dummyimg.png";
import Button from "react-bootstrap/Button";

const AllEmployees = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [showAadhaarModal, setShowAadhaarModal] = useState(false);
  const [selectedAadhaarData, setSelectedAadhaarData] = useState(null);
  const [DeletedItem, setDeletedItem] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleClose = () => {
    setshowDeleteModal(false);
    setDeletedItem("");
  };

  const handleAadhaarClose = () => {
    setShowAadhaarModal(false);
    setSelectedAadhaarData(null);
  };

  const handleViewClose = () => {
    setShowViewModal(false);
    setSelectedEmployee(null);
  };

  const PlusHandler = () => {
    navigate("/Adm/Employees/AddEmployee");
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return "---";
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return "---";
    return date.toLocaleDateString("en-GB");
  };

  const getGenderText = (gender) => {
    if (gender === 0) return "Male";
    if (gender === 1) return "Female";
    if (gender === 2) return "Other";
    return "---";
  };

  const GetAllEmployee = () => {
    setLoading(true);
    const token = GetToken();

    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetAllEmployees`,
    };

    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data || "[]");
        setAllEmployeeData(data);
        setLeaveRequestDuplicate(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetAllEmployee();
  }, []);

  const DeleteHandler = () => {
    const LoginToken = GetToken();

    const data = {
      Id: DeletedItem?.Id,
    };

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/DeleteEmployee`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((e) => {
        if (e?.status === 200) {
          toast.success(e?.data?.message || "Employee deleted successfully");
          setshowDeleteModal(false);
          setDeletedItem("");
          GetAllEmployee();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Failed to delete employee");
      });
  };

  const handleEyeGetEmployee = (item) => {
    setSelectedEmployee(item);
    setShowViewModal(true);
  };

  const handleAadhaarPreview = (employee) => {
    const documents = [];

    if (employee?.AadharCardFront) documents.push(employee.AadharCardFront);
    if (employee?.AadharCardBack) documents.push(employee.AadharCardBack);

    if (
      employee?.AadharFiles &&
      Array.isArray(employee.AadharFiles) &&
      employee.AadharFiles.length > 0
    ) {
      documents.push(...employee.AadharFiles);
    }

    setSelectedAadhaarData({
      firstName: employee?.FirstName,
      lastName: employee?.LastName,
      documents: documents,
    });

    setShowAadhaarModal(true);
  };

  const handleDownloadAadhaar = (imageUrl, fileName) => {
    if (!imageUrl) {
      toast.error("No document available for download");
      return;
    }

    try {
      downloadFile(imageUrl, fileName);
    } catch (error) {
      toast.error("Failed to download document");
    }
  };

  const handleDownloadAllAadhaarDocuments = (employee) => {
    if (!employee) {
      toast.error("No employee data available");
      return;
    }

    const fileUrls = [];
    const firstName = employee?.FirstName || "aadhaar";

    if (employee?.AadharCardFront) {
      fileUrls.push({
        url: employee.AadharCardFront,
        fileName: `${firstName}_aadhaar_front`,
      });
    }

    if (employee?.AadharCardBack) {
      fileUrls.push({
        url: employee.AadharCardBack,
        fileName: `${firstName}_aadhaar_back`,
      });
    }

    if (
      employee?.AadharFiles &&
      Array.isArray(employee.AadharFiles) &&
      employee.AadharFiles.length > 0
    ) {
      employee.AadharFiles.forEach((fileUrl, index) => {
        fileUrls.push({
          url: fileUrl,
          fileName: `${firstName}_aadhaar_file_${index + 1}`,
        });
      });
    }

    if (fileUrls.length > 0) {
      downloadMultipleFiles(fileUrls);
    } else {
      toast.error("No documents available for download");
    }
  };

  const EditHandler = (e) => {
    navigate("/Adm/Employees/AddEmployee", { state: e });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handelDeleteModalOpen = (item) => {
    setDeletedItem(item);
    setshowDeleteModal(true);
  };

  const handleDataSearch = (e) => {
    const searchTerm = e?.target?.value?.toLowerCase();

    if (searchTerm) {
      const filteredData = leaveRequestDuplicate?.filter((item) =>
        `${item?.FirstName || ""} ${item?.LastName || ""}`
          .toLowerCase()
          .includes(searchTerm)
      );
      setAllEmployeeData(filteredData);
    } else {
      setAllEmployeeData(leaveRequestDuplicate);
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page"
              : "main-container-of-all-employees-page-new"
          }
        >
          <div className="inner-container-of-all-employees-page ">
            <div className="header-of-employees-page row">
              <div className="all-employee-text col">
                <h4>All Employee</h4>
              </div>

              <div className="all-employees-directory col">
                <div className="home-icon-header">
                  <BiHomeAlt className="home-icon-header-inn" />
                </div>
                <div className="arrow-icon-header">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-header">
                  <p>Employees</p>
                </div>
                <div className="arrow-icon-header">
                  <MdKeyboardArrowRight />
                </div>
                <div className="all-employee-text-header">
                  <p>All Employee</p>
                </div>
              </div>
            </div>
          </div>

          <div className="body-part-outer-container">
            <div className="inner-body-container-of-employee-table row-12">
              <div className="all-employees-first-side-in-body-header col-6">
                <div className="allemployee-text-in-body">
                  <h2>Employees</h2>
                </div>
                <div className="all-employee-input-for-search-in-employee-body">
                  <MdSearch className="search-icon-in-input" />
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={handleDataSearch}
                  />
                </div>
              </div>

              <div className="images-section-on-body col-6 ">
                <div className="plus-button-in-body">
                  <button onClick={PlusHandler}>
                    <FaPlus className="plusbutton-icon" />
                  </button>
                </div>

                <div className="reloard-button-in-body">
                  <button onClick={GetAllEmployee}>
                    <GrRefresh className="refreshbutton-icon" />
                  </button>
                </div>
              </div>
            </div>

            <div className="table-in-all-emplyee-body">
              <table className="table-main-class">
                <thead className="thead-main-class">
                  <tr className="row-12">
                    <th>Sr.no </th>
                    <th className="col-1">Image</th>
                    <th className="col-1">Name</th>
                    <th className="col-2">Email</th>
                    <th className="col-3">Department</th>
                    <th className="col-3">Designation</th>
                    <th className="col-2">Laptop Assigned</th>
                    <th className="col-2">Aadhaar</th>
                    <th className="col-1">Actions</th>
                  </tr>
                </thead>

                <tbody className="tbody-main-class">
                  {allEmployeeData?.length ? (
                    <>
                      {allEmployeeData?.map((item, index) => {
                        return (
                          <tr key={index} className="tr-all-employee-tbl">
                            <td>{index + 1}</td>

                            <td>
                              {item?.UrlLink ? (
                                <img
                                  className="image-of-header"
                                  src={item.UrlLink || "/placeholder.svg"}
                                  onError={(e) => {
                                    e.target.src = dummyimage;
                                  }}
                                  alt="Profile"
                                />
                              ) : (
                                <img
                                  src={dummyimage || "/placeholder.svg"}
                                  alt="Profile"
                                  className="profile-icon-header"
                                />
                              )}
                            </td>

                            <td>
                              {item?.FirstName
                                ? `${item?.FirstName} ${item?.LastName || ""}`.trim()
                                : "---"}
                            </td>

                            <td>{item?.Email ? item?.Email : "---"}</td>

                            <td>
                              {item?.Positions?.RoleName === "Admin"
                                ? "Admin"
                                : item?.Departments?.Name
                                ? item?.Departments?.Name
                                : "---"}
                            </td>

                            <td>
                              {item?.Positions?.RoleName === "Admin"
                                ? "Admin"
                                : item?.Designations?.DesignationName
                                ? item?.Designations?.DesignationName
                                : "---"}
                            </td>

                            <td>
                              {item?.LaptopAssigned ? item?.LaptopAssigned : "---"}
                            </td>

                            <td className="aadhaar-icon-in-td">
                              {(() => {
                                const hasAadharFront = !!item?.AadharCardFront;
                                const hasAadharBack = !!item?.AadharCardBack;
                                const hasAadharFiles =
                                  item?.AadharFiles &&
                                  Array.isArray(item?.AadharFiles) &&
                                  item?.AadharFiles.length > 0;

                                const totalDocs =
                                  (hasAadharFront ? 1 : 0) +
                                  (hasAadharBack ? 1 : 0) +
                                  (hasAadharFiles ? item?.AadharFiles.length : 0);

                                return totalDocs > 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "12px",
                                      alignItems: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() => handleAadhaarPreview(item)}
                                      title={`View Aadhaar (${totalDocs} document(s))`}
                                      style={{
                                        background: "#f0f0f0",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "6px 10px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        color: "#333",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <AiOutlineEye
                                        style={{
                                          fontSize: "18px",
                                          marginRight: "4px",
                                        }}
                                      />
                                    </button>

                                    <button
                                      onClick={() =>
                                        handleDownloadAllAadhaarDocuments(item)
                                      }
                                      title={`Download All (${totalDocs} document(s))`}
                                      style={{
                                        background: "#f0f0f0",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "6px 10px",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        color: "#333",
                                        fontSize: "14px",
                                      }}
                                    >
                                      <AiOutlineDownload
                                        style={{
                                          fontSize: "18px",
                                          marginRight: "4px",
                                        }}
                                      />
                                    </button>
                                  </div>
                                ) : (
                                  "---"
                                );
                              })()}
                            </td>

                            <td className="edit-icon-in-td">
                              <FaEdit
                                className="edit-icon-main"
                                onClick={() => EditHandler(item)}
                              />

                              <RiDeleteBinLine
                                className="delete-icon-main"
                                onClick={() => handelDeleteModalOpen(item)}
                              />

                              <RiEyeCloseFill
                                className="eye-icon-main"
                                onClick={() => handleEyeGetEmployee(item)}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr className="no-record-found-tr-dashboard">
                      <td colSpan="10">No record found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal>

      {/* Delete Modal */}
      <Modal show={showDeleteModal} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="Flex-container-of-allEMp-modal">
            <div>
              <p>
                <span className="AllEMP-Modal-headings">First Name:</span>{" "}
                {DeletedItem?.FirstName || "---"}
              </p>
              <p>
                <span className="AllEMP-Modal-headings">Last Name:</span>{" "}
                {DeletedItem?.LastName || "---"}
              </p>
              <p>
                <span className="AllEMP-Modal-headings">Mobile:</span>{" "}
                {DeletedItem?.Mobile || "---"}
              </p>
            </div>

            <p>
              {DeletedItem?.UrlLink ? (
                <img
                  className="image-of-delete-modal"
                  src={DeletedItem?.UrlLink || "/placeholder.svg"}
                  onError={(e) => {
                    e.target.src = dummyimage;
                  }}
                  alt="Employee"
                />
              ) : (
                <img
                  alt="Employee"
                  src={dummyimage || "/placeholder.svg"}
                  className="profile-icon-header"
                />
              )}
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="Close-Button-forAllEmp"
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </Button>

          <Button
            className="Delete-modal-forAllEmp"
            variant="primary"
            onClick={DeleteHandler}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Aadhaar Preview Modal */}
      <Modal
        show={showAadhaarModal}
        onHide={handleAadhaarClose}
        size="lg"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Aadhaar Documents - {selectedAadhaarData?.firstName}{" "}
            {selectedAadhaarData?.lastName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="aadhaar-preview-container">
            {selectedAadhaarData?.documents &&
            selectedAadhaarData?.documents.length > 0 ? (
              selectedAadhaarData?.documents.map((docUrl, index) => {
                let docLabel = `Document ${index + 1}`;
                if (index === 0 && selectedAadhaarData?.documents.length >= 1) {
                  docLabel = "Front";
                }
                if (index === 1 && selectedAadhaarData?.documents.length >= 2) {
                  docLabel = "Back";
                }

                return (
                  <div key={index} className="aadhaar-card-section">
                    <h6 className="aadhaar-card-label">Aadhaar {docLabel}</h6>

                    {docUrl?.toLowerCase()?.endsWith(".pdf") ? (
                      <div
                        className="pdf-preview"
                        style={{
                          padding: "20px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "5px",
                          textAlign: "center",
                        }}
                      >
                        <p>📄 PDF Document</p>
                        <p style={{ fontSize: "12px", color: "#666" }}>
                          File: {docUrl.split("/").pop()}
                        </p>
                      </div>
                    ) : (
                      <img
                        src={docUrl || "/placeholder.svg"}
                        alt={`Aadhaar ${docLabel}`}
                        className="aadhaar-preview-image"
                        style={{ maxHeight: "300px", objectFit: "cover" }}
                        onError={(e) => {
                          e.target.src = dummyimage;
                        }}
                      />
                    )}

                    <button
                      className="btn btn-sm btn-primary mt-2"
                      onClick={() =>
                        handleDownloadAadhaar(
                          docUrl,
                          `${selectedAadhaarData?.firstName}_aadhaar_${docLabel.toLowerCase()}`
                        )
                      }
                    >
                      <AiOutlineDownload /> Download {docLabel}
                    </button>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  color: "#999",
                }}
              >
                No Aadhaar documents available
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* View Employee Modal */}
      <Modal
        show={showViewModal}
        onHide={handleViewClose}
        size="lg"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Employee Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedEmployee ? (
            <div className="view-employee-container">
              <div className="row">
                <div className="col-md-4 text-center mb-3">
                  <img
                    src={selectedEmployee?.UrlLink || dummyimage}
                    alt="Profile"
                    onError={(e) => {
                      e.target.src = dummyimage;
                    }}
                    style={{
                      width: "130px",
                      height: "130px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #eee",
                    }}
                  />
                </div>

                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong>First Name:</strong>{" "}
                        {selectedEmployee?.FirstName || "---"}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Last Name:</strong>{" "}
                        {selectedEmployee?.LastName || "---"}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p>
                        <strong>Email:</strong> {selectedEmployee?.Email || "---"}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Mobile:</strong>{" "}
                        {selectedEmployee?.Mobile || "---"}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p>
                        <strong>Gender:</strong>{" "}
                        {getGenderText(selectedEmployee?.Gender)}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Role:</strong>{" "}
                        {selectedEmployee?.Positions?.RoleName || "---"}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p>
                        <strong>Department:</strong>{" "}
                        {selectedEmployee?.Departments?.Name || "---"}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Designation:</strong>{" "}
                        {selectedEmployee?.Designations?.DesignationName || "---"}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p>
                        <strong>Date of Birth:</strong>{" "}
                        {formatDate(selectedEmployee?.DateOfBirth)}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>Date of Joining:</strong>{" "}
                        {formatDate(selectedEmployee?.DateofJoining)}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p>
                        <strong>Laptop Assigned:</strong>{" "}
                        {selectedEmployee?.LaptopAssigned || "---"}
                      </p>
                    </div>

                    <div className="col-12">
                      <p>
                        <strong>Address:</strong>{" "}
                        {selectedEmployee?.Address || "---"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <h5 style={{ marginBottom: "15px" }}>Aadhaar Documents</h5>

              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                }}
              >
                {selectedEmployee?.AadharCardFront ? (
                  <div>
                    <p style={{ fontWeight: "600", marginBottom: "8px" }}>
                      Front
                    </p>
                    <img
                      src={selectedEmployee?.AadharCardFront}
                      alt="Aadhaar Front"
                      onError={(e) => {
                        e.target.src = dummyimage;
                      }}
                      style={{
                        width: "220px",
                        maxWidth: "100%",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                ) : null}

                {selectedEmployee?.AadharCardBack ? (
                  <div>
                    <p style={{ fontWeight: "600", marginBottom: "8px" }}>
                      Back
                    </p>
                    <img
                      src={selectedEmployee?.AadharCardBack}
                      alt="Aadhaar Back"
                      onError={(e) => {
                        e.target.src = dummyimage;
                      }}
                      style={{
                        width: "220px",
                        maxWidth: "100%",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                ) : null}

                {!selectedEmployee?.AadharCardFront &&
                !selectedEmployee?.AadharCardBack ? (
                  <p>No Aadhaar documents available</p>
                ) : null}
              </div>
            </div>
          ) : (
            <p>No data available</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleViewClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AllEmployees;